import gql from 'graphql-tag'

const stockAdvicesSendToWMSQuery = gql`
  query stockAdvicesSendToWMSQuery($status: String!, $stockAdvices: [String]!) {
    stockAdvicesSendToWMSQuery(status: $status, input: { stockAdvices: $stockAdvices })
      @rest(method: "PUT", path: "stock-advice/status/{args.status}") {
      results
    }
  }
`

export default stockAdvicesSendToWMSQuery
